import * as React from 'react';
import { IconButton, Badge } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useGetList } from 'react-admin';
import { NotificationPanel } from './NotificationPanel';

export const NotificationButton = () => {
  const [isPanelOpen, setPanelOpen] = React.useState(false);

  // 1. useGetListフックで未読通知の件数を取得します
  const { total, isLoading, refetch } = useGetList(
    'notifications', // 通知リソースのエンドポイント名
    {
      // 件数だけ取得できれば良いので、ページネーションは最小限に設定
      pagination: { page: 1, perPage: 1 },
      // バックエンドの仕様に合わせてフィルタを定義 (例: readAtがnullのもの)
      filter: { readAt: null }
    },
    {
      // パネルが開いている間は、バックグラウンドでのデータ取得を停止
      enabled: !isPanelOpen
    }
  );

  const handleOpen = () => {
    setPanelOpen(true);
  };

  const handleClose = () => {
    setPanelOpen(false);
    // 3. パネルを閉じたら、未読件数を再取得してバッジを更新します
    refetch();
  };

  return (
    <>
      <IconButton onClick={handleOpen} color="inherit" aria-label="show notifications" disabled={isLoading}>
        {/* 2. Badgeコンポーネントでアイコンを囲み、badgeContentに件数を渡します */}
        <Badge badgeContent={total} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <NotificationPanel open={isPanelOpen} onClose={handleClose} />
    </>
  );
};
